import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Search } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const DatabaseLookupNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Database Lookup'}
        icon={Search}
        colorClass="from-amber-500 to-amber-700"
        bgClass="bg-gradient-to-br from-amber-500 to-amber-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
DatabaseLookupNode.displayName = 'DatabaseLookupNode';
export default DatabaseLookupNode;
